module.exports = __webpack_public_path__ + "img/deck_builder.bedc2885.jpg";